import React, {Component} from 'react';
import {Modal, Button, Row}  from 'react-bootstrap'
import SecondServer from '../database/SecondServer'
import FormFactory from '../FormData/FormFactory';
import {Header, SpacerCol, InputCommon, inputBorder} from '../Modal/CommonParts.js'
import ExpireInput from './ExpireInput';
import { sanitizeDateTime } from '../timeFunctions/timeFns.js';
import { siteAccessCode } from '../database/apiv2SiteAccessor';
import { urlRequest } from '../database/apiUrls';
import {accessCodeValid} from '../FormData/Validators'

import '../Report/report-header.css'
import '../Report/Controls/massedit.css'
import '../commoninputs.css'
import '../Sites/siteadd.css'

export default class GrantRequest extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      errMsg: null,
      rerender: 0,
      saving: false,
      currentTab: 1,
    }
    this.requestAttribs = ["requestedBy", "company", "requestEndDate", "requestReason"]
    if (this.props.newSiteRequest) this.requestAttribs.unshift('acValue')
    this.valid = this.inputsValid();
    this.handleClose = this.handleClose.bind(this);
    this.validate = this.validate.bind(this);
    this.validateAndMoveOn = this.validateAndMoveOn.bind(this);
    this.ff = new FormFactory()
  }

  inputsValid () {
    return Object.fromEntries(this.requestAttribs.map(value => [value, true]));
  }

  componentDidMount() {
    this.initState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.opened !== this.props?.opened)
      this.initState();
  }

  initState () {
    this.ff.init()
    this.setState ({errMsg: null})
    this.valid = this.inputsValid();
    const defaultExp = new Date ()
    defaultExp.setMonth(defaultExp.getMonth() + 3)
    this.ff.addInitialChange('requestEndDate', defaultExp)
  }
  
  async saveChanges() {
    this.setState({saving: true})
    let ss = new SecondServer(this.props);
    let saveObj = this.ff.jsonifyInputs(this.requestAttribs);
    saveObj = this.addContext(saveObj);
    //console.log (saveObj)
    await ss.apiInsertData (urlRequest(), saveObj);
    const msg = ss.getErrorMsg()
    this.props.updateSiteListCache('perms', null) //cachePermission (null) // invalidate cache for this site
    this.setState ( {errMsg: msg, saving: false } );
    return msg
  }

  addContext (obj) {
    obj['serverCreds'] = this.props.userLogin;
    obj['requestDate'] = new Date().toLocaleDateString();
    if (!this.props.newSiteRequest)
      obj['acValue'] = siteAccessCode(this.props.getActiveSite());
    if (this.props.AC)
      obj['acValue'] = this.props.AC
    return obj;
  }

  async handleClose() {
    this.props.hide();
    this.initState();
  }

  handleChange = event => {
    this.ff.handleChange(event);
    this.setState ({rerender: this.state.rerender+1})
  }
  expChange = event => {
    if (event?.target) {
      const glue = {
        target: {
          id: event.target?.id,
          value: sanitizeDateTime(event.target.value)
        }
      }
      this.ff.handleChange(glue)
    }
    else {
      const glue2 = {
        target: {
          id: 'requestEndDate',
          value: event
        }
      }
      this.ff.handleChange(glue2)
    }
    this.setState ({rerender: this.state.rerender+1})
  }

  isBlank(fieldName) {
    this.valid[fieldName] = !this.ff.isBlank(fieldName);
    return !this.valid[fieldName]
  }

  validate () {
    if (this.props.newSiteRequest) {
      if (this.isBlank('acValue'))
        return "You gotta pick a site"
      const option = this.ff.findChange ('acValue')
      if (accessCodeValid(option?.value))
        return "Site access code needs to be an 11 digit number"
    }

    if (this.isBlank('requestedBy'))
      return "Name cannot be blank"

    return null;
  }
  
  async moveOn (msg) {
    const result = await this.saveChanges();
    if (!result)
      this.setState({currentTab: this.state.currentTab + 1})
    // this.handleClose();

    if (this.props.onChange)
      this.props.onChange(this.state);
  }

  validateAndMoveOn() {
    const msg = this.validate();
    this.setState({errMsg: msg}) 
    if (msg === null) 
      this.moveOn ()
  }
  modalInput (id, prompt, valid=true, inputSize=35) {
    const bcolor = inputBorder(valid);
    const prev_item = this.ff.findChange(id)
    const toDisplay = prev_item ? prev_item.value : ""
    return (<InputCommon id={id} prompt={prompt} element=
      {<input className={"compact-item "+bcolor} type="text" value={toDisplay} id={id} size={inputSize}
        onChange={this.handleChange}/>}
    />)
  }
  dateInput (id, prompt) {
    const disp = this.ff.findChange(id)?.value ?? new Date()
    const bcolor = "compact-item "+inputBorder(this.valid[id])
    return (
      <InputCommon id={id} prompt={prompt} element=
        {<ExpireInput from={disp} className={bcolor} id={id} size='35' onChange={this.expChange} />}
      /> 
    )
  }
  renderTopPart () {
    if (this.props.newSiteRequest) {
      return(
        <Row className='mt-5 modal-top-row'>
          {this.modalInput('acValue', 'Requested Site Access Code', this.valid["requestedBy"])}
        </Row>
      )
    }
    else return <p className='body-text'>Request permission</p>
  }

  yourStyle () {
    const rowStyle = 'mt-5'
    if (this.props.newSiteRequest)
      return rowStyle
    else
      return rowStyle+' modal-top-row'
  }
  renderFooter () {
    if (this.state.currentTab < 2)
      return (
        <Modal.Footer>
          <div className="modal-error">{this.state.errMsg}</div>
          <Button className="custom-std-btn" onClick={()=>this.handleClose()} 
            disabled={this.state.saving}>Cancel</Button>
          <Button className="custom-std-btn" onClick={()=>this.validateAndMoveOn()} 
            disabled={this.state.saving}>Send Request</Button>
        </Modal.Footer>
      )
    return (
      <Modal.Footer>
        <Button className="custom-std-btn" onClick={()=>this.handleClose()}>Ok</Button>
      </Modal.Footer>
    )
  }
  renderTab2() {
    return(
      <Modal.Body className='body-indent'>
        Your grant request has been submitted. Once it is approved, you will gain 
        access to the requested site
      </Modal.Body>
    )
  }
  renderTab1() {
    return(
      <Modal.Body className='body-indent'>
        {this.renderTopPart()}
        <Row className={this.yourStyle()}>
          {this.modalInput('requestedBy', 'Your Name', this.valid["requestedBy"])}
          <SpacerCol />
          {this.modalInput('company', 'Company', true)}
        </Row>
        <Row className='mt-5'>
          {this.dateInput('requestEndDate', 'Grant Until', this.valid["requestEndDate"])}
          <SpacerCol />
          {this.modalInput('requestReason', 'Reason', true)}
        </Row>
      </Modal.Body>
    )
  }
  renderTab () {
    return this.state.currentTab < 2 ? this.renderTab1() : this.renderTab2()
  }
  render() {
    const headerText = this.props.newSiteRequest ? 
      "Request permission to view a site":
      "You need permission to view this site";
    return(
      <Modal show={this.props.show} onHide={this.handleClose} size="lg">
        <Header title={headerText} />
        {this.renderTab()}
        {this.renderFooter()}
      </Modal>
    )
  }
}
